// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".compilations-wrapper[data-v-2e372a63]{padding-bottom:100px;-webkit-box-sizing:border-box;box-sizing:border-box;max-width:1920px;margin:auto}.compilation-title[data-v-2e372a63]{margin-top:50px}@media screen and (max-width:600px){.compilations-wrapper[data-v-2e372a63]{padding-bottom:60px}}", ""]);
// Exports
module.exports = exports;
